import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { FaCaretRight, FaCaretDown } from 'react-icons/fa';
import { Button } from 'react-bootstrap';
import styles from '../order-review.module.scss';

import { HelpPopOver } from '../../../infrastructure/forms/help-tip-icon/HelpTipIcon';
import { MoneyDisplay } from '../../order-selection/starter-kit-selection/util-starter-kit/MoneyDisplay';
import { ListPrice } from '../util/ListPrice';
import { OrderTotalTaxCard } from '../util/OrderTotalTaxCard';
import { useModuleStore } from '../../enrollment-process/module-management/model/ModuleStoreHook';

export const OrderTotalReview = observer(() => {
  const { t } = useTranslation();

  const orderReviewStore = useModuleStore('orderTotalReview');

  return (
    <div className="p-3 mt-3 bg-light">
      <ListPrice price={orderReviewStore.subtotal} label="Subtotal" />
      <ListPrice price={orderReviewStore.shipping} label="Shipping" />
      <div className="d-flex">
        <Button
          variant="link"
          className="mr-auto p-0"
          onClick={() => orderReviewStore.switchTabTaxDefinition(!orderReviewStore.activeTaxTab)}
        >
          {t('TaxTotal')}{' '}
          {orderReviewStore.activeTaxTab === true ? (
            <FaCaretDown className={styles.mainColor} />
          ) : (
            <FaCaretRight className={styles.mainColor} />
          )}
        </Button>

        <span>
          <MoneyDisplay price={orderReviewStore.taxTotal} />
        </span>
      </div>
      {orderReviewStore.activeTaxTab === true ? <OrderTotalTaxCard store={orderReviewStore} /> : ''}
      <hr />

      <div>
        <h5>
          <ListPrice price={orderReviewStore.total} label="Total" />
        </h5>
      </div>

      <div className="d-flex">
        <span className="mr-auto">
          {t('PVTotal')} <HelpPopOver label="PvDescription" />
        </span>

        <span>
          <MoneyDisplay numberOnly price={orderReviewStore.pvTotal} />
        </span>
      </div>
    </div>
  );
});
